export default __webpack_public_path__ + "static/media/enter_data_with_csv.ad902a55.svg";